import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import {
  getCompaniesDetails,
  getCompaniesResume,
} from '../../services/Companies/getCompanies'

export const useCompaniesDetailsDetails = () => {
  const { id } = useParams()

  const [companiesDetails, setCompaniesDetailsResume] =
    useState<GetProductResumeType>()
  const [clientsDetails, setClientsDetails] = useState<GetDetailsType[]>([])
  const [clientsLow, setClientsLow] = useState<GetDetailsType[]>([])
  const [isLoading, setIsloading] = useState(true)

  const handleCompaniesDetailsResume = async () => {
    setIsloading(true)
    const result = await getCompaniesResume(id!)
    setIsloading(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      setCompaniesDetailsResume(result)
    }
  }

  const handleClientsDetails = async (
    status: Classification,
    callback: (result: GetDetailsType[]) => void
  ) => {
    setIsloading(true)
    const result = await getCompaniesDetails(id!, status)
    setIsloading(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      callback(result)
    }
  }

  const handleClientsInHigh = (result: GetDetailsType[]) => {
    const resultMapped = result.map(SalesPeople => ({
      ...SalesPeople,
      percentual: String(SalesPeople.percentual).replace('.', ','),
    }))
    setClientsDetails(resultMapped)
  }

  const handleClientsLow = (result: GetDetailsType[]) => {
    const resultMapped = result.map(SalesPeople => ({
      ...SalesPeople,
      percentual: String(SalesPeople.percentual).replace('.', ','),
    }))
    setClientsLow(resultMapped)
  }

  useEffect(() => {
    handleClientsDetails('EM_ALTA', handleClientsInHigh)
    handleClientsDetails('EM_BAIXA', handleClientsLow)
  }, [])

  useEffect(() => {
    handleCompaniesDetailsResume()
  }, [])

  return {
    companiesDetails,
    clientsDetails,
    clientsLow,
    isLoading,
  }
}
